export default "__VITE_ASSET__CW49P2Ui__"